import { render, staticRenderFns } from "./playerDailySnapshot.vue?vue&type=template&id=63fcb812&scoped=true&"
import script from "./playerDailySnapshot.vue?vue&type=script&lang=js&"
export * from "./playerDailySnapshot.vue?vue&type=script&lang=js&"
import style0 from "./playerDailySnapshot.vue?vue&type=style&index=0&id=63fcb812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fcb812",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63fcb812')) {
      api.createRecord('63fcb812', component.options)
    } else {
      api.reload('63fcb812', component.options)
    }
    module.hot.accept("./playerDailySnapshot.vue?vue&type=template&id=63fcb812&scoped=true&", function () {
      api.rerender('63fcb812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/playerDailySnapshot/playerDailySnapshot.vue"
export default component.exports